/**
 * Returns a CSS `color-mix()` expression that applies the given opacity
 * percentage to the Chakra color token, producing a theme-aware transparent
 * variant.
 *
 * @example
 * withAlpha('blue.500', 8) // "color-mix(in srgb, var(--chakra-colors-blue-500) 8%, transparent)"
 */
export const withAlpha = (token: string, percent: number): string =>
  `color-mix(in srgb, var(--chakra-colors-${token.replace(
    '.',
    '-'
  )}) ${percent}%, transparent)`;
